import { render, staticRenderFns } from "./statistics-home.vue?vue&type=template&id=08689fcc&scoped=true"
import script from "./statistics-home.vue?vue&type=script&lang=js"
export * from "./statistics-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08689fcc",
  null
  
)

export default component.exports